import { loadNewsletterPageData, updateNewsletterPopUpData } from '../actions/newsletterAction';
import {
    newsletterPage as newsletterLandingPage,
    requestFormPage,
    thankYouPage,
    welcomePage,
} from '../consts/pageTypes';
import {
    isNewsletterModalCookie,
    hasNewsletterHiddenCookie,
    readCookie,
    writeCookie,
    writeSessionCookie,
    isNewsletterBannerSession,
    isNewsletterModalSession,
    NEWSLETTER_MODAL_DELAY,
    YEAR_IN_MILISECONDS,
    isSignedUpForNewsletter,
} from './cookie';
import { eventTracker } from './EventTracker/EventTracker';
import { getRouteSlugs } from './routing';
import { C1AU_DOMAIN } from '../context/markets';

/**
 * Checks specific queryparams to create newsletter cookie
 */
export const checkNewsletterQuerystringParams = (
    url_string: string,
    ssr: boolean,
    response?: any,
) => {
    const url = new URL(url_string);
    const params = new URLSearchParams(url.search?.toLowerCase());

    const isHideNewsletterParamExists = params.has('hnlp');
    // hide newsletter modal regarding ticket DREAM-17680
    if (isHideNewsletterParamExists) {
        // we should set both cookies SSR and Client because of the CF cache
        if (ssr) {
            response.cookie('__hNLP', `true`);
        } else {
            writeSessionCookie('__hNLP', 'true');
        }
    }

    const utm_source = url.searchParams.get('utm_source');
    const utm_medium = url.searchParams.get('utm_medium');

    const isNewsletterSource = utm_source?.includes('newsletter_') || utm_medium === 'email';

    if (isNewsletterSource) {
        if (!readCookie('isSignedUpForNewsletter')) {
            if (ssr) {
                response.cookie('isSignedUpForNewsletter', `true`, {
                    maxAge: YEAR_IN_MILISECONDS, // for express js, maxAge is in milliseconds
                });
            } else {
                writeCookie('isSignedUpForNewsletter', 'true', 365);
            }
        }
    }
};

export const initNewsletterPopUp = (store) => {
    new NewsletterPopUp(store);
};

// DREAM-17821 Temporarily disable the newsletter pop up on a particular page for Cruise1st.com.au
const excludeNewsletterModalFromC1AUPage = (routePath, market) => {
    const isC1AU = C1AU_DOMAIN === market;
    const excludePageList = ['travelzoo-exclusive-rome-to-rio-iguazu-falls'];
    return excludePageList.includes(routePath?.split('/')[1]) && isC1AU;
};
export class NewsletterPopUp {
    store: any;
    timeoutId: number;
    resetTimerInterval: number = 0;

    constructor(store) {
        this.store = store;
        this.newsletterBanner();
        this.newsletterModal(5000);
    }

    newsletterBanner = () => {
        const { pageData, newsletterPage } = this.store.getState();
        let shouldShowNewsletterBanner = this.shouldShowNewsletterBanner();
        const newState = {
            popUp: {
                ...newsletterPage.popUp,
                shouldShowNewsletterBanner,
            },
        };

        updateNewsletterPopUpData(newState)(this.store.dispatch);
    };

    newsletterModal = (timeout) => {
        window.clearInterval(this.timeoutId);
        const { pageData } = this.store.getState();
        const { pageType, brandConfig } = pageData;
        let shouldShowNewsletterModal = this.shouldShowNewsletterModal();

        this.timeoutId = window.setInterval(() => {
            if (!shouldShowNewsletterModal) this.cancelNewsletterModal();
            this.cancelNewsletterModal();

            window.setTimeout(() => {
                const { newsletterPage } = this.store.getState();

                eventTracker.track({
                    event: 'event',
                    category: 'newsletter-PI',
                    action: 'click',
                    label: pageType,
                });

                const newState = {
                    popUp: {
                        ...newsletterPage.popUp,
                        shouldShowNewsletterModal,
                        timeout,
                    },
                };

                updateNewsletterPopUpData(newState)(this.store.dispatch);
            }, NEWSLETTER_MODAL_DELAY);
        }, timeout);
    };

    cancelNewsletterModal = () => {
        window.clearInterval(this.timeoutId);
    };

    shouldShowNewsletterBanner = () => {
        const { pageData, router } = this.store.getState();
        const { brandConfig } = pageData;
        const { pageType, path } = router;

        const excludeNewsletterModalList = [
            newsletterLandingPage,
            requestFormPage,
            thankYouPage,
            welcomePage,
        ];
        const newsletterModalFeatureFlag = pageData?.featureFlags?.find(
            (e) => e.feature === 'newsletterModal',
        );
        const isNewsletterModalEnabledByFeatureFlag = newsletterModalFeatureFlag
            ? newsletterModalFeatureFlag?.isEnabled
            : false;

        const disableNewsletterModalOnLP = excludeNewsletterModalFromC1AUPage(
            path,
            brandConfig.portalId,
        );

        const shouldShowNewsletterModal =
            isNewsletterBannerSession() &&
            !isNewsletterModalCookie() &&
            !hasNewsletterHiddenCookie() &&
            !isSignedUpForNewsletter() &&
            !disableNewsletterModalOnLP &&
            excludeNewsletterModalList.indexOf(pageType) === -1 &&
            isNewsletterModalEnabledByFeatureFlag;

        return shouldShowNewsletterModal;
    };

    shouldShowNewsletterModal = () => {
        const { pageData, router, newsletterPage } = this.store.getState();
        const { brandConfig, appConfig } = pageData;
        const { pageType, path } = router;

        const excludeNewsletterModalList = [
            newsletterLandingPage,
            requestFormPage,
            thankYouPage,
            welcomePage,
        ];
        const newsletterModalFeatureFlag = pageData?.featureFlags?.find(
            (e) => e.feature === 'newsletterModal',
        );
        const isNewsletterModalEnabledByFeatureFlag = newsletterModalFeatureFlag
            ? newsletterModalFeatureFlag?.isEnabled
            : false;

        const disableNewsletterModalOnLP = excludeNewsletterModalFromC1AUPage(
            path,
            brandConfig.portalId,
        );

        const shouldShowNewsletterModal =
            isNewsletterModalSession() &&
            !isNewsletterModalCookie() &&
            !hasNewsletterHiddenCookie() &&
            !isSignedUpForNewsletter() &&
            !disableNewsletterModalOnLP &&
            excludeNewsletterModalList.indexOf(pageType) === -1 &&
            isNewsletterModalEnabledByFeatureFlag;
        const routeSlugs = getRouteSlugs(brandConfig.slugs);
        const newsletterPageSlug = routeSlugs.NewsletterPage;
        if (shouldShowNewsletterModal && !newsletterPage.title) {
            loadNewsletterPageData(this.store.dispatch, appConfig.apiHost, newsletterPageSlug);
        }

        return shouldShowNewsletterModal;
    };
}
